// extracted by mini-css-extract-plugin
export default {"toolFrameworkErrorBulletBlack":"ToolFramework404Error_toolFrameworkErrorBulletBlack__NlPjQ","toolFrameworkErrorText":"ToolFramework404Error_toolFrameworkErrorText__XofpD"};